/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_How_3_CInputs */

const en_mk_how_3_c = /** @type {(inputs: Mk_How_3_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Review combined results and check evidence before continuing`)
};

const id_mk_how_3_c = /** @type {(inputs: Mk_How_3_CInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tinjau hasil gabungan dan bukti pemeriksaannya sebelum lanjut`)
};

/**
* | output |
* | --- |
* | "Review combined results and check evidence before continuing" |
*
* @param {Mk_How_3_CInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_how_3_c = /** @type {((inputs?: Mk_How_3_CInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_How_3_CInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_how_3_c(inputs)
	return en_mk_how_3_c(inputs)
});